import { DeliveryMethod } from '@/domain/models/Order/deliveryMethod';
import { OrderMethod } from '@/domain/models/Order/orderMethod';
import { getClient } from '@/lib/restClient';
import { EatInSettings } from '@/pages/store-management/master-stores/components/Sidebar/MasterStoreSidebarForm/service';
import { StoreManagementDeliveryStoreService } from '@/services/StoreManagement/DeliveryStores/StoreManagementDeliveryStoreService';

export type StoreManagementDeliveryStoreCreateParams = {
  master_store_id: number;
  external_store_id: string;
  delivery_service_id: number;
  external_auth_delivery_store: {
    email: string;
    password: string;
    username: string;
  };
  camel_order_cooking_time: number | null;
  camel_order_prop: {
    takeout_start_days_offset: number | null;
    takeout_end_days_offset: number | null;
    order_methods: OrderMethod[];
    delivery_methods: DeliveryMethod[];
    eat_in_settings?: EatInSettings | null;
  } | null;
};

export type StoreManagementDeliveryStoreCreateResponse = {
  id: string;
};

export const useStoreManagementDeliveryStoreCreate = async (
  params: StoreManagementDeliveryStoreCreateParams
): Promise<StoreManagementDeliveryStoreCreateResponse> => {
  const storeManagementDeliveryStoreService =
    new StoreManagementDeliveryStoreService(getClient());
  return await storeManagementDeliveryStoreService.create(params);
};
